export default {
  common: {
    form: {
      save: "Speichern",
      requiredText: "* = Feld muss abgefüllt werden",
      required: "Feld ist ein Pflichtfeld",
      requiredEmail: "Emailfeld ist ein Pflichtfeld",
      validEmail: "Email ist ungültig"
    },
    actions: {
      logout: "Ausloggen",
      administration: "Verwaltung",
      mainAdministration: "Hauptverwaltung",
      delete: "Löschen"
    },
    list: {
      actions: "Aktionen",
    },
    propPanel: {
      save: "Speichern"
    },
    labels: {
      close: "Schliessen"
    }
  },

  login: {
    form: {
      title: "Login",
      username: "User/Benutzername",
      password: "Password/Passwort",
      submit: "Login/Einloggen",
    },
  },

  visitor: {
    form:  {
      title: "Registration",
      name: "Name",
      firstname: "Vorname",
      lastname: "Nachname",
      company: "Unternehmung",
      addr: "Addresse",
      zip: "PLZ",
      city: "Wohnort",
      email: "E-Mail Adresse",
      submit: "Absenden"
    }
  },

  logout: {
    pageTitle: "Ausgeloogt",
    body: "Sie sind nun ausgeloggt",
    backToLogin: "Zurück zur login Seite",
  },

  question: {
    title: "Frage stellen",
    form: {
      title: "Titel",
      author: "Autor",
      body: "Frage",
      link: "Link",
    },
    added: "Frage hinzugefügt",
    missingContent: "Title und Content müssen ausgefüllt werden"
  },

  vote:  {
    title: "Abstimmung"
  },

  admin: {
    nav: {
      home: "Home",
      adminHome: "Admin home",
      userManagement: "Benutzerverwaltung",
      customerManagement: "Kundenverwaltung",
      qTimes: "Fragen filters"
    },
    section: {
      customers: "Kunden",
    },
    userManagement: {
      addUser: "Add user",
      pageTitle: "Benutzerverwaltung",
      importUsers: "Benutzer importieren"
    },
    customerManagement: {
      pageTitle: "Kundenverwaltung",
      addCustomer: "Kunde hinzufügen"
    },
    qTimes: {
      pageTitle: "Fragen filters",
      addTime: "Filter hinzufügen"
    }
  },

  customers: {
    list:{
      name: "Kundenname",
      playerUrl: "Player url",
      description: "Beschreibung"
    }
  },

  users: {
    list: {
      name: "Name",
      email: "E-Mail",
      state: "Status",
      role: "Rolle",
      customer: "Kunde",
      lastLoginDate: "Letzer login",
      lang: "Sprache"
    },
    edit:{
      password: {
        title: "Passwort setzen",
        password: "Passwort",
        passwordValidation: "Passwort verifizieren",
        showPasswordInClear: "Passwort im Klartext anzeigen",
        change: {
          submit: "Speichern"
        }
      }
    },
    delete: {
      confirmMessage: "Wollen Sie diesen Benutzer wirklich löschen?"
    }
  },

  home: {
    addQuestion: "Frage stellen"
  },

  customer: {
    nav: {
      home: {
        default: "Player",
        de: "Player de",
        en: "Player en"
      },
      view: "view",
      adminHome: "Admin home",
      questionList: "Frage Verwaltung",
      voteList: "Umfrage Verwaltung",
      register: "Registrierungsseite"
    },
    admin:{
      info:{
        title: "Willkommen in der Verwaltung",
        body: ""
      },
      questions:{
        title: "Fragen Liste",
        add: "Frage Hinzufügen"
      },
      votes: {
        title: "Umfragen Liste",
        add: "Umfragen hinzufügen",
        total: "Total Umfragen",
        state: "Umfrage aktiv",
        details: "Details"
      }
    },
    votes:{
      yes: "Ja",
      no: "Nein",
      abstention: "Enthalten",
    }
  },

  qTimes:{
    list: {
      name: "Filter name",
      customer: "Kunde",
      from: "Gültig von",
      to: "Gültig bis"
    },
    delete: {
      confirmMessage: "Wirklich löschen?"
    }
  }
};
